import {graphql, useStaticQuery} from "gatsby"

export const useArticleImages = () => {
  const query = useStaticQuery(graphql`
      query {
          thumb: file(relativePath: { eq: "img/Blog/article_8/thumb.png" }) {
              childImageSharp {
                  fluid(maxWidth: 700, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                      ...GatsbyImageSharpFluidLimitPresentationSize
                  }
              }
          }
          event: file(relativePath: { eq: "img/Blog/article_8/thumb.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                      ...GatsbyImageSharpFluidLimitPresentationSize
                  }
              }
          }
          img1: file(relativePath: { eq: "img/Blog/article_8/img_1.png" }) {
              childImageSharp {
                  fluid(maxWidth: 495, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                      ...GatsbyImageSharpFluidLimitPresentationSize
                  }
              }
          }
      }
  `)
  return query
}
